import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function LitigeSocieteRelax({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Monsieur,</p>
      <p>
        La Société {variablesData.erreur_livraison_societe} m'a informée par
        téléphone que les produits livrés le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.erreur_livraison_date_livraison) || 0,
        )}{" "}
        ne correspondaient pas aux spécifications du contrat.
      </p>
      <p>
        Nous leur avons fourni 5000 articles type 4013E alors qu'ils demandaient
        des articles type 4041E. Ils désirent par conséquent un échange immédiat
        ; or, il ne nous reste en stock que 6000 articles 4041E qui doivent être
        impérativement livrés le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.societe_a_livrer_date_livraison) || 0,
        )}{" "}
        à la Société {variablesData.societe_a_livrer_societe}.
      </p>
      <p>Que faut-il faire ?</p>
      <MailSignature
        emetteurLogo={LitigeSocieteRelax.metadata.emetteurLogo}
        emetteur={LitigeSocieteRelax.metadata.emetteur}
        emetteurPoste={LitigeSocieteRelax.metadata.emetteurPoste}
        emetteurEntreprise={LitigeSocieteRelax.metadata.emetteurEntreprise}
      />
    </div>
  );
}

LitigeSocieteRelax.metadata = {
  titre: "Litige Société RELAX",
  cleMail: "litige_societe_relax",
  messageTransfert: false,
  emetteur: "Leïla SEBAG",
  emetteurPoste: "Responsable du Service Commercial",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -2,
  piecesJointes: [],
} as MailMetadata;

export default LitigeSocieteRelax;
